import React from 'react'
import PropTypes from 'prop-types';
import style from './style.css'

export default class NoBlueprintsView extends React.Component {

  render() {
    return ( 
      <div className={style.noItems}>Create a blueprint to get started</div>
    );
  }
}
